import useShopDataProducts from '@hooks/product/useShopDataProducts';
import { useMemo } from 'react';
import Product from '@models/product';
import { ProductModelProps } from '@typings/product';

const useProducts = (productData?: Array<ProductModelProps> | Array<Product>, fullData = false) => {
  const products = useMemo(
    () => productData?.map((data) => (data instanceof Product ? data : new Product(data))) ?? [],
    [productData],
  );
  const skus = products.map((product) => product.sku);
  const { data: shopDataProducts = [], isLoading } = useShopDataProducts(skus, fullData);

  const productsWithShop = useMemo(
    () =>
      products.map((product) => {
        const shopData = shopDataProducts?.find((s) => s?.sku === product.sku);

        if (shopData) {
          product.setShop(shopData);
        }

        return product;
      }) ?? [],
    [products, shopDataProducts],
  );
  return { products: productsWithShop, isLoading };
};

export default useProducts;
